import { AnyAction, ActionCreator } from "redux";
import { SetFilter, GetPaginated } from "./types";
import { PptFilter } from "./types";
import * as actionTypes from "./actionTypes";
import { PptType } from "../tournaments/types";

export const getPaginated: ActionCreator<GetPaginated> = (
  page: number,
  key: PptType
) => ({
  type: actionTypes.PPT_GET_PPT_PAGINATED,
  page,
  key
});

export const filterPpt: ActionCreator<SetFilter> = (
  filter: PptFilter,
  key: PptType
) => ({
  type: actionTypes.PPT_FILTER_PPT,
  filter,
  key
});

export const getPptScrim= (): AnyAction => ({
  type: actionTypes.PPT_GET_PPT_SCRIM,
});

export const getPptCup = (): AnyAction => ({
  type: actionTypes.PPT_GET_PPT_CUP,
});

export const getPptMaster = (): AnyAction => ({
  type: actionTypes.PPT_GET_PPT_MASTER,
});